<template>
    <div class="main">
      <message-head v-show="!loading" :type="spot.available ? 'success' : 'fail'" :title="spot.available ? '此车位可用' : '此车位暂不可用'">
        <span v-if="!spot.available">{{spot.cause}} 请试试其它车位</span>
        <span v-else-if="spot.lesee">当前处于月租时段</span>
        <span v-else>当前处于临停时段</span>
      </message-head>
      <br />
      <van-cell-group v-if="spot.needPlateNumber">
        <van-cell title="请填写您的车牌号:" label="离场时可实现自动开闸放行">
          <plate-number-input v-model="lastPlate"></plate-number-input>
        </van-cell>
      </van-cell-group>
      <van-cell-group>
        <van-cell title="车位" :value="(spot.lotName || '') + ' ' + (spot.name || '')"  />
      </van-cell-group>
      <van-collapse v-model="activeNames">
        <van-collapse-item title="临停收费价格" name="1">
          <charge-rule :chargeRule="spot.chargeRule" />
        </van-collapse-item>
      </van-collapse>
      <div class="tips" v-if="spot.available">请在现场工作人员的协助下, 将您的车辆停放到对应车位台板上, 确认安全无误后, 点击开始计费</div>
      <div class="buttons">
          <van-button v-if="!spot.available" block type="primary" disabled>停车</van-button>
          <van-button v-else-if="spot.parkMode=='TWICE_SCAN' && spot.scanned" block type="primary" @click="parking()">
            <span v-if="spot.lesee">确认停车</span>
            <span v-else>开始计费</span>
          </van-button>
          <van-button v-else-if="spot.parkMode=='TWICE_SCAN' && !spot.scanned" block type="primary" @click="scan()">信息已过期,请重新扫一扫车位二维码</van-button>
          <van-button v-else block type="primary" disabled>车辆停好后将自动计费</van-button>
          <br />
          <van-button block type="default" @click="close()">取消</van-button>
      </div>
    </div>
</template>

<script>
import { Button, Cell, CellGroup, Collapse, CollapseItem, Icon } from 'vant';
import qs from 'query-string';
import MessageHead from '../components/MessageHead.vue';
import { router } from '../router';
import ChargeRule from '../components/ChargeRule.vue';
import PlateNumberInputVue from '../components/PlateNumberInput.vue';

export default {
  components: {
    [Icon.name] : Icon,
    [Cell.name] : Cell,
    [CellGroup.name] : CellGroup,
    [Collapse.name] : Collapse,
    [CollapseItem.name] : CollapseItem,
    [Button.name] : Button,
    'message-head' : MessageHead,
    'charge-rule' : ChargeRule,
    'plate-number-input': PlateNumberInputVue
  },
  data() {
    return {
      activeNames: [],
      spot: {},
      lastPlate: null,
      loading: false
    };
  },
  mounted() {
    const q = qs.parse(location.search);
    const {qrcode, devId} = q;
    const that = this;
    this.loading = true;
    // 记录用户二维码扫描
    this.$http.post('/member/parking_scan', { qrcode: qrcode || devId }).then(()=>{
      this.$http.get('/member/parking_status').then(function(status){
        if (status.parkingStatus == 0) {
          router.push('/parking');
        } else {
          that.$http.get('/parking/parking_spot', {qrcode, deviceId: devId}).then(spot => {
            that.loading = false;
            that.spot = spot || {};
            if (that.spot.parkMode=="ONCE_SCAN" && that.spot.orderId) {
              router.push('/parking?orderId='+that.spot.orderId)
            } else if (that.spot.available && spot.needPlateNumber) {
              that.$http.get('/parking/last_cars', {parkingLotId: spot.lotId }).then(function(result){
                  that.lastPlate = result.last;
              });
            }
          }).finally(()=>that.loading = false)
        }
    })
    });
    
  },
  methods: {
   parking() {
      this.$http.post('/order', { spotId: this.spot.id , plateNumber : this.lastPlate}).then(function(){
        router.push('/parking');
      })
    },
    scan() {
        router.push('/scan');
    },
    close() {
      this.$wechat.sdk(sdk => sdk.closeWindow());
    }
  }
};
</script>

<style lang="less" scoped>
  .buttons {
    padding: 10px;
    margin-top: 50px;
  }
  .tips {
    font-size: 12px;
    color: gray;
    padding: 10px;
  }
</style>